export default "__VITE_ASSET__hHgLlZID__"